enum TmxProfileResultEnumeration {
  COMPLETED = 'COMPLETED',
  TIMEOUT = 'TIMEOUT',
}

export { TmxProfileResultEnumeration };
